export default "__VITE_ASSET__D0v4CHqQ__"